import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import * as sodium from 'libsodium-wrappers';
import axios from 'axios';
import { getHexHash, toHex, recipientString, openCryptobox, encryptCryptoboxPayload, decryptCryptoboxPayload } from '../../utils/crypto';
import { MatrixClient } from '../../matrix-client/MatrixClient';
import { MatrixClientEventType } from '../../matrix-client/models/MatrixClientEvent';
import { MatrixMessageType } from '../../matrix-client/models/MatrixMessage';
import { PeerManager, StorageKey } from '../..';
import { BEACON_VERSION } from '../../constants';
import { generateGUID } from '../../utils/generate-uuid';
import { getSenderId } from '../../utils/get-sender-id';
import { Logger } from '../../utils/Logger';
import { CommunicationClient } from './CommunicationClient';
import { ExposedPromise } from '../../utils/exposed-promise';
var logger = new Logger('P2PCommunicationClient');
export var KNOWN_RELAY_SERVERS = ['beacon-node-1.diamond.papers.tech', 'beacon-node-1.sky.papers.tech', 'beacon-node-2.sky.papers.tech', 'beacon-node-1.hope.papers.tech', 'beacon-node-1.hope-2.papers.tech', 'beacon-node-1.hope-3.papers.tech', 'beacon-node-1.hope-4.papers.tech', 'beacon-node-0.papers.tech:8448'];
/**
 * @internalapi
 */

export var P2PCommunicationClient = /*#__PURE__*/function (_CommunicationClient) {
  _inherits(P2PCommunicationClient, _CommunicationClient);

  var _super = _createSuper(P2PCommunicationClient);

  function P2PCommunicationClient(name, keyPair, replicationCount, storage, matrixNodes, iconUrl, appUrl) {
    var _this;

    _classCallCheck(this, P2PCommunicationClient);

    _this = _super.call(this, keyPair);
    _this.name = name;
    _this.replicationCount = replicationCount;
    _this.storage = storage;
    _this.iconUrl = iconUrl;
    _this.appUrl = appUrl;
    _this.client = new ExposedPromise();
    _this.activeListeners = new Map();
    _this.ignoredRooms = [];
    _this.loginCounter = 0;
    logger.log('constructor', 'P2PCommunicationClient created');
    var nodes = matrixNodes.length > 0 ? matrixNodes : KNOWN_RELAY_SERVERS;
    _this.ENABLED_RELAY_SERVERS = nodes;
    return _this;
  }

  _createClass(P2PCommunicationClient, [{
    key: "getPairingRequestInfo",
    value: function getPairingRequestInfo() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var info;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return generateGUID();

              case 2:
                _context.t0 = _context.sent;
                _context.t1 = this.name;
                _context.t2 = BEACON_VERSION;
                _context.next = 7;
                return this.getPublicKey();

              case 7:
                _context.t3 = _context.sent;
                _context.next = 10;
                return this.getRelayServer();

              case 10:
                _context.t4 = _context.sent;
                info = {
                  id: _context.t0,
                  type: 'p2p-pairing-request',
                  name: _context.t1,
                  version: _context.t2,
                  publicKey: _context.t3,
                  relayServer: _context.t4
                };

                if (this.iconUrl) {
                  info.icon = this.iconUrl;
                }

                if (this.appUrl) {
                  info.appUrl = this.appUrl;
                }

                return _context.abrupt("return", info);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getPairingResponseInfo",
    value: function getPairingResponseInfo(request) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var info;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = request.id;
                _context2.t1 = this.name;
                _context2.t2 = BEACON_VERSION;
                _context2.next = 5;
                return this.getPublicKey();

              case 5:
                _context2.t3 = _context2.sent;
                _context2.next = 8;
                return this.getRelayServer();

              case 8:
                _context2.t4 = _context2.sent;
                info = {
                  id: _context2.t0,
                  type: 'p2p-pairing-response',
                  name: _context2.t1,
                  version: _context2.t2,
                  publicKey: _context2.t3,
                  relayServer: _context2.t4
                };

                if (this.iconUrl) {
                  info.icon = this.iconUrl;
                }

                if (this.appUrl) {
                  info.appUrl = this.appUrl;
                }

                return _context2.abrupt("return", info);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getRelayServer",
    value: function getRelayServer() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var node, nodes, index, server;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.relayServer) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", this.relayServer.promise);

              case 4:
                this.relayServer = new ExposedPromise();

              case 5:
                _context3.next = 7;
                return this.storage.get(StorageKey.MATRIX_SELECTED_NODE);

              case 7:
                node = _context3.sent;

                if (!(node && node.length > 0)) {
                  _context3.next = 11;
                  break;
                }

                this.relayServer.resolve(node);
                return _context3.abrupt("return", node);

              case 11:
                nodes = _toConsumableArray(this.ENABLED_RELAY_SERVERS);

              case 12:
                if (!(nodes.length > 0)) {
                  _context3.next = 29;
                  break;
                }

                index = Math.floor(Math.random() * nodes.length);
                server = nodes[index];
                _context3.prev = 15;
                _context3.next = 18;
                return axios.get("https://".concat(server, "/_matrix/client/versions"));

              case 18:
                this.storage.set(StorageKey.MATRIX_SELECTED_NODE, server).catch(function (error) {
                  return logger.log(error);
                });
                this.relayServer.resolve(server);
                return _context3.abrupt("return", server);

              case 23:
                _context3.prev = 23;
                _context3.t0 = _context3["catch"](15);
                logger.log("Ignoring server \"".concat(server, "\", trying another one..."));
                nodes.splice(index, 1);

              case 27:
                _context3.next = 12;
                break;

              case 29:
                this.relayServer.reject("No matrix server reachable!");
                throw new Error("No matrix server reachable!");

              case 31:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[15, 23]]);
      }));
    }
  }, {
    key: "tryJoinRooms",
    value: function tryJoinRooms(roomId) {
      var retry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.client.promise;

              case 3:
                _context5.next = 5;
                return _context5.sent.joinRooms(roomId);

              case 5:
                _context5.next = 10;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);

                if (retry <= 10 && _context5.t0.errcode === 'M_FORBIDDEN') {
                  // If we join the room too fast after receiving the invite, the server can accidentally reject our join. This seems to be a problem only when using a federated multi-node setup. Usually waiting for a couple milliseconds solves the issue, but to handle lag, we will keep retrying for 2 seconds.
                  logger.log("Retrying to join...", _context5.t0);
                  setTimeout(function () {
                    return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              _context4.next = 2;
                              return this.tryJoinRooms(roomId, retry + 1);

                            case 2:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4, this);
                    }));
                  }, 200);
                } else {
                  logger.log("Failed to join after ".concat(retry, " tries."), _context5.t0);
                }

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 7]]);
      }));
    }
  }, {
    key: "start",
    value: function start() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _this3 = this;

        var loginRawDigest, rawSignature, relayServer, client;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                logger.log('start', 'starting client');
                _context8.next = 3;
                return sodium.ready;

              case 3:
                loginRawDigest = sodium.crypto_generichash(32, sodium.from_string("login:".concat(Math.floor(Date.now() / 1000 / (5 * 60)))));
                rawSignature = sodium.crypto_sign_detached(loginRawDigest, this.keyPair.privateKey);
                logger.log('start', "connecting to server");
                _context8.next = 8;
                return this.getRelayServer();

              case 8:
                relayServer = _context8.sent;
                client = MatrixClient.create({
                  baseUrl: "https://".concat(relayServer),
                  storage: this.storage
                });

                this.initialListener = function (event) {
                  return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            if (this.initialEvent && this.initialEvent.timestamp && event && event.timestamp) {
                              if (this.initialEvent.timestamp < event.timestamp) {
                                this.initialEvent = event;
                              }
                            } else {
                              this.initialEvent = event;
                            }

                          case 1:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6, this);
                  }));
                };

                client.subscribe(MatrixClientEventType.MESSAGE, this.initialListener);
                client.subscribe(MatrixClientEventType.INVITE, function (event) {
                  return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                    var member;
                    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            if (event.content.members.length === 1) {
                              // If there is only one member we know it's a new room
                              // TODO: Use the "sender" of the event instead
                              member = event.content.members[0];
                            }

                            _context7.next = 3;
                            return this.tryJoinRooms(event.content.roomId);

                          case 3:
                            if (!member) {
                              _context7.next = 8;
                              break;
                            }

                            _context7.next = 6;
                            return this.updateRelayServer(member);

                          case 6:
                            _context7.next = 8;
                            return this.updatePeerRoom(member, event.content.roomId);

                          case 8:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7, this);
                  }));
                });
                _context8.t0 = logger;
                _context8.next = 16;
                return this.getPublicKeyHash();

              case 16:
                _context8.t1 = _context8.sent;
                _context8.t2 = relayServer;

                _context8.t0.log.call(_context8.t0, 'start', 'login', _context8.t1, 'on', _context8.t2);

                _context8.prev = 19;
                _context8.t3 = client;
                _context8.next = 23;
                return this.getPublicKeyHash();

              case 23:
                _context8.t4 = _context8.sent;
                _context8.t5 = "ed:".concat(toHex(rawSignature), ":");
                _context8.next = 27;
                return this.getPublicKey();

              case 27:
                _context8.t6 = _context8.sent;
                _context8.t7 = _context8.t5.concat.call(_context8.t5, _context8.t6);
                _context8.t8 = toHex(this.keyPair.publicKey);
                _context8.t9 = {
                  id: _context8.t4,
                  password: _context8.t7,
                  deviceId: _context8.t8
                };
                _context8.next = 33;
                return _context8.t3.start.call(_context8.t3, _context8.t9);

              case 33:
                _context8.next = 48;
                break;

              case 35:
                _context8.prev = 35;
                _context8.t10 = _context8["catch"](19);
                console.log('ERROR, RETRYING');
                _context8.next = 40;
                return this.reset();

              case 40:
                // If we can't log in, let's reset
                console.log('TRYING AGAIN');

                if (!(this.loginCounter <= this.ENABLED_RELAY_SERVERS.length)) {
                  _context8.next = 47;
                  break;
                }

                this.loginCounter++;
                this.start();
                return _context8.abrupt("return");

              case 47:
                throw new Error('Too many login attempts. Try again later.');

              case 48:
                console.log('client is ready');
                this.client.resolve(client);

              case 50:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[19, 35]]);
      }));
    }
  }, {
    key: "stop",
    value: function stop() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!this.client.isResolved()) {
                  _context9.next = 5;
                  break;
                }

                _context9.next = 3;
                return this.client.promise;

              case 3:
                _context9.next = 5;
                return _context9.sent.stop().catch(function (error) {
                  return logger.error(error);
                });

              case 5:
                _context9.next = 7;
                return this.reset();

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "reset",
    value: function reset() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.storage.delete(StorageKey.MATRIX_PEER_ROOM_IDS).catch(function (error) {
                  return logger.log(error);
                });

              case 2:
                _context10.next = 4;
                return this.storage.delete(StorageKey.MATRIX_PRESERVED_STATE).catch(function (error) {
                  return logger.log(error);
                });

              case 4:
                _context10.next = 6;
                return this.storage.delete(StorageKey.MATRIX_SELECTED_NODE).catch(function (error) {
                  return logger.log(error);
                });

              case 6:
                // Instead of resetting everything, maybe we should make sure a new instance is created?
                this.relayServer = undefined;
                this.client = new ExposedPromise();
                this.initialEvent = undefined;
                this.initialListener = undefined;

              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "listenForEncryptedMessage",
    value: function listenForEncryptedMessage(senderPublicKey, messageCallback) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _this4 = this;

        var _yield$this$createCry, sharedRx, callbackFunction, lastEvent, initialListener;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!this.activeListeners.has(senderPublicKey)) {
                  _context12.next = 2;
                  break;
                }

                return _context12.abrupt("return");

              case 2:
                _context12.next = 4;
                return this.createCryptoBoxServer(senderPublicKey, this.keyPair.privateKey);

              case 4:
                _yield$this$createCry = _context12.sent;
                sharedRx = _yield$this$createCry.sharedRx;

                callbackFunction = function callbackFunction(event) {
                  return __awaiter(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
                    var payload, decryptedMessage;
                    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            _context11.t0 = this.isTextMessage(event.content);

                            if (!_context11.t0) {
                              _context11.next = 5;
                              break;
                            }

                            _context11.next = 4;
                            return this.isSender(event, senderPublicKey);

                          case 4:
                            _context11.t0 = _context11.sent;

                          case 5:
                            if (!_context11.t0) {
                              _context11.next = 21;
                              break;
                            }

                            _context11.next = 8;
                            return this.updateRelayServer(event.content.message.sender);

                          case 8:
                            _context11.next = 10;
                            return this.updatePeerRoom(event.content.message.sender, event.content.roomId);

                          case 10:
                            try {
                              payload = Buffer.from(event.content.message.content, 'hex'); // content can be non-hex if it's a connection open request
                            } catch (_a) {
                              /* */
                            }

                            if (!(payload && payload.length >= sodium.crypto_secretbox_NONCEBYTES + sodium.crypto_secretbox_MACBYTES)) {
                              _context11.next = 21;
                              break;
                            }

                            _context11.prev = 12;
                            _context11.next = 15;
                            return decryptCryptoboxPayload(payload, sharedRx);

                          case 15:
                            decryptedMessage = _context11.sent;
                            // logger.log(
                            //   'listenForEncryptedMessage',
                            //   'encrypted message received',
                            //   decryptedMessage,
                            //   await new Serializer().deserialize(decryptedMessage)
                            // )
                            // console.log('calculated sender ID', await getSenderId(senderPublicKey))
                            // TODO: Add check for correct decryption key / sender ID
                            messageCallback(decryptedMessage);
                            _context11.next = 21;
                            break;

                          case 19:
                            _context11.prev = 19;
                            _context11.t1 = _context11["catch"](12);

                          case 21:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11, this, [[12, 19]]);
                  }));
                };

                this.activeListeners.set(senderPublicKey, callbackFunction);
                _context12.next = 10;
                return this.client.promise;

              case 10:
                _context12.sent.subscribe(MatrixClientEventType.MESSAGE, callbackFunction);

                lastEvent = this.initialEvent;

                if (!(lastEvent && lastEvent.timestamp && new Date().getTime() - lastEvent.timestamp < 5 * 60 * 1000)) {
                  _context12.next = 18;
                  break;
                }

                logger.log('listenForEncryptedMessage', 'Handling previous event');
                _context12.next = 16;
                return callbackFunction(lastEvent);

              case 16:
                _context12.next = 19;
                break;

              case 18:
                logger.log('listenForEncryptedMessage', 'No previous event found');

              case 19:
                initialListener = this.initialListener;

                if (!initialListener) {
                  _context12.next = 25;
                  break;
                }

                ;
                _context12.next = 24;
                return this.client.promise;

              case 24:
                _context12.sent.unsubscribe(MatrixClientEventType.MESSAGE, initialListener);

              case 25:
                this.initialListener = undefined;
                this.initialEvent = undefined;

              case 27:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "unsubscribeFromEncryptedMessage",
    value: function unsubscribeFromEncryptedMessage(senderPublicKey) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var listener;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                listener = this.activeListeners.get(senderPublicKey);

                if (listener) {
                  _context13.next = 3;
                  break;
                }

                return _context13.abrupt("return");

              case 3:
                ;
                _context13.next = 6;
                return this.client.promise;

              case 6:
                _context13.sent.unsubscribe(MatrixClientEventType.MESSAGE, listener);

                this.activeListeners.delete(senderPublicKey);

              case 8:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "unsubscribeFromEncryptedMessages",
    value: function unsubscribeFromEncryptedMessages() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                ;
                _context14.next = 3;
                return this.client.promise;

              case 3:
                _context14.sent.unsubscribeAll(MatrixClientEventType.MESSAGE);

                this.activeListeners.clear();

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(message, peer) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var _this5 = this;

        var _yield$this$createCry2, sharedTx, recipientHash, recipient, roomId, encryptedMessage;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.createCryptoBoxClient(peer.publicKey, this.keyPair.privateKey);

              case 2:
                _yield$this$createCry2 = _context17.sent;
                sharedTx = _yield$this$createCry2.sharedTx;
                _context17.next = 6;
                return getHexHash(Buffer.from(peer.publicKey, 'hex'));

              case 6:
                recipientHash = _context17.sent;
                recipient = recipientString(recipientHash, peer.relayServer);
                _context17.next = 10;
                return this.getRelevantRoom(recipient);

              case 10:
                roomId = _context17.sent;
                _context17.next = 13;
                return this.waitForJoin(roomId);

              case 13:
                _context17.next = 15;
                return encryptCryptoboxPayload(message, sharedTx);

              case 15:
                encryptedMessage = _context17.sent;
                _context17.next = 18;
                return this.client.promise;

              case 18:
                _context17.sent.sendTextMessage(roomId, encryptedMessage).catch(function (error) {
                  return __awaiter(_this5, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
                    var _this6 = this;

                    var newRoomId;
                    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                      while (1) {
                        switch (_context16.prev = _context16.next) {
                          case 0:
                            if (!(error.errcode === 'M_FORBIDDEN')) {
                              _context16.next = 12;
                              break;
                            }

                            // Room doesn't exist
                            logger.log("sendMessage", "M_FORBIDDEN", error);
                            _context16.next = 4;
                            return this.deleteRoomIdFromRooms(roomId);

                          case 4:
                            _context16.next = 6;
                            return this.getRelevantRoom(recipient);

                          case 6:
                            newRoomId = _context16.sent;
                            _context16.next = 9;
                            return this.client.promise;

                          case 9:
                            _context16.sent.sendTextMessage(newRoomId, encryptedMessage).catch(function (error2) {
                              return __awaiter(_this6, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
                                return _regeneratorRuntime.wrap(function _callee15$(_context15) {
                                  while (1) {
                                    switch (_context15.prev = _context15.next) {
                                      case 0:
                                        logger.log("sendMessage", "inner error", error2);

                                      case 1:
                                      case "end":
                                        return _context15.stop();
                                    }
                                  }
                                }, _callee15);
                              }));
                            });

                            _context16.next = 13;
                            break;

                          case 12:
                            logger.log("sendMessage", "not forbidden", error);

                          case 13:
                          case "end":
                            return _context16.stop();
                        }
                      }
                    }, _callee16, this);
                  }));
                });

              case 19:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "updatePeerRoom",
    value: function updatePeerRoom(sender, roomId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var split, roomIds, room;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                // Sender is in the format "@pubkeyhash:relayserver.tld"
                split = sender.split(':');

                if (!(split.length < 2 || !split[0].startsWith('@'))) {
                  _context18.next = 3;
                  break;
                }

                throw new Error('Invalid sender');

              case 3:
                _context18.next = 5;
                return this.storage.get(StorageKey.MATRIX_PEER_ROOM_IDS);

              case 5:
                roomIds = _context18.sent;
                room = roomIds[sender];

                if (room && room[1]) {
                  // If we have a room already, let's ignore it. We need to do this, otherwise it will be loaded from the matrix cache.
                  this.ignoredRooms.push(room[1]);
                }

                roomIds[sender] = roomId;
                _context18.next = 11;
                return this.storage.set(StorageKey.MATRIX_PEER_ROOM_IDS, roomIds);

              case 11:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "deleteRoomIdFromRooms",
    value: function deleteRoomIdFromRooms(roomId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var roomIds, newRoomIds;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.storage.get(StorageKey.MATRIX_PEER_ROOM_IDS);

              case 2:
                roomIds = _context19.sent;
                newRoomIds = Object.entries(roomIds).filter(function (entry) {
                  return entry[1] !== roomId;
                }).reduce(function (pv, cv) {
                  return Object.assign(Object.assign({}, pv), _defineProperty({}, cv[0], cv[1]));
                }, {});
                _context19.next = 6;
                return this.storage.set(StorageKey.MATRIX_PEER_ROOM_IDS, newRoomIds);

              case 6:
                // TODO: We also need to delete the room from the sync state
                // If we need to delete a room, we can assume the local state is not up to date anymore, so we can reset the state
                this.ignoredRooms.push(roomId);

              case 7:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
    }
  }, {
    key: "listenForChannelOpening",
    value: function listenForChannelOpening(messageCallback) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var _this7 = this;

        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                ;
                _context21.next = 3;
                return this.client.promise;

              case 3:
                _context21.sent.subscribe(MatrixClientEventType.MESSAGE, function (event) {
                  return __awaiter(_this7, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
                    var splits, payload, pairingResponse;
                    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                      while (1) {
                        switch (_context20.prev = _context20.next) {
                          case 0:
                            _context20.t0 = this.isTextMessage(event.content);

                            if (!_context20.t0) {
                              _context20.next = 5;
                              break;
                            }

                            _context20.next = 4;
                            return this.isChannelOpenMessage(event.content);

                          case 4:
                            _context20.t0 = _context20.sent;

                          case 5:
                            if (!_context20.t0) {
                              _context20.next = 33;
                              break;
                            }

                            logger.log("listenForChannelOpening", "channel opening", JSON.stringify(event));
                            _context20.next = 9;
                            return this.updateRelayServer(event.content.message.sender);

                          case 9:
                            _context20.next = 11;
                            return this.updatePeerRoom(event.content.message.sender, event.content.roomId);

                          case 11:
                            splits = event.content.message.content.split(':');
                            payload = Buffer.from(splits[splits.length - 1], 'hex');

                            if (!(payload.length >= sodium.crypto_secretbox_NONCEBYTES + sodium.crypto_secretbox_MACBYTES)) {
                              _context20.next = 33;
                              break;
                            }

                            _context20.prev = 14;
                            _context20.t1 = JSON;
                            _context20.next = 18;
                            return openCryptobox(payload, this.keyPair.publicKey, this.keyPair.privateKey);

                          case 18:
                            _context20.t2 = _context20.sent;
                            pairingResponse = _context20.t1.parse.call(_context20.t1, _context20.t2);
                            _context20.t3 = messageCallback;
                            _context20.t4 = Object;
                            _context20.t5 = Object.assign({}, pairingResponse);
                            _context20.next = 25;
                            return getSenderId(pairingResponse.publicKey);

                          case 25:
                            _context20.t6 = _context20.sent;
                            _context20.t7 = {
                              senderId: _context20.t6
                            };
                            _context20.t8 = _context20.t4.assign.call(_context20.t4, _context20.t5, _context20.t7);
                            (0, _context20.t3)(_context20.t8);
                            _context20.next = 33;
                            break;

                          case 31:
                            _context20.prev = 31;
                            _context20.t9 = _context20["catch"](14);

                          case 33:
                          case "end":
                            return _context20.stop();
                        }
                      }
                    }, _callee20, this, [[14, 31]]);
                  }));
                });

              case 4:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
    }
  }, {
    key: "waitForJoin",
    value: function waitForJoin(roomId) {
      var retry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        var _this8 = this;

        var room;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this.client.promise;

              case 2:
                _context23.next = 4;
                return _context23.sent.getRoomById(roomId);

              case 4:
                room = _context23.sent;
                logger.log("waitForJoin", "Currently ".concat(room.members.length, " members, we need at least 2"));

                if (!(room.members.length >= 2 || room.members.length === 0)) {
                  _context23.next = 10;
                  break;
                }

                return _context23.abrupt("return");

              case 10:
                if (!(retry <= 200)) {
                  _context23.next = 15;
                  break;
                }

                // On mobile, due to app switching, we potentially have to wait for a long time
                logger.log("Waiting for join... Try: ".concat(retry));
                return _context23.abrupt("return", new Promise(function (resolve) {
                  setTimeout(function () {
                    return __awaiter(_this8, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
                      return _regeneratorRuntime.wrap(function _callee22$(_context22) {
                        while (1) {
                          switch (_context22.prev = _context22.next) {
                            case 0:
                              resolve(this.waitForJoin(roomId, retry + 1));

                            case 1:
                            case "end":
                              return _context22.stop();
                          }
                        }
                      }, _callee22, this);
                    }));
                  }, 100 * (retry > 50 ? 10 : 1)); // After the initial 5 seconds, retry only once per second
                }));

              case 15:
                throw new Error("No one joined after ".concat(retry, " tries."));

              case 16:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
    }
  }, {
    key: "sendPairingResponse",
    value: function sendPairingResponse(pairingRequest) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        var _this9 = this;

        var recipientHash, recipient, roomId, message, encryptedMessage, msg;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                logger.log("sendPairingResponse");
                _context26.next = 3;
                return getHexHash(Buffer.from(pairingRequest.publicKey, 'hex'));

              case 3:
                recipientHash = _context26.sent;
                recipient = recipientString(recipientHash, pairingRequest.relayServer); // We force room creation here because if we "re-pair", we need to make sure that we don't send it to an old room.

                _context26.next = 7;
                return this.client.promise;

              case 7:
                _context26.next = 9;
                return _context26.sent.createTrustedPrivateRoom(recipient);

              case 9:
                roomId = _context26.sent;
                _context26.next = 12;
                return this.updatePeerRoom(recipient, roomId);

              case 12:
                _context26.next = 14;
                return this.waitForJoin(roomId);

              case 14:
                if (!(typeof pairingRequest.version === 'undefined')) {
                  _context26.next = 20;
                  break;
                }

                _context26.next = 17;
                return this.getPublicKey();

              case 17:
                _context26.t0 = _context26.sent;
                _context26.next = 25;
                break;

              case 20:
                _context26.t1 = JSON;
                _context26.next = 23;
                return this.getPairingResponseInfo(pairingRequest);

              case 23:
                _context26.t2 = _context26.sent;
                _context26.t0 = _context26.t1.stringify.call(_context26.t1, _context26.t2);

              case 25:
                message = _context26.t0;
                _context26.next = 28;
                return this.encryptMessageAsymmetric(pairingRequest.publicKey, message);

              case 28:
                encryptedMessage = _context26.sent;
                msg = ['@channel-open', recipient, encryptedMessage].join(':');
                _context26.next = 32;
                return this.client.promise;

              case 32:
                _context26.sent.sendTextMessage(roomId, msg).catch(function (error) {
                  return __awaiter(_this9, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
                    var _this10 = this;

                    var newRoomId;
                    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
                      while (1) {
                        switch (_context25.prev = _context25.next) {
                          case 0:
                            if (!(error.errcode === 'M_FORBIDDEN')) {
                              _context25.next = 12;
                              break;
                            }

                            // Room doesn't exist
                            logger.log("sendMessage", "M_FORBIDDEN", error);
                            _context25.next = 4;
                            return this.deleteRoomIdFromRooms(roomId);

                          case 4:
                            _context25.next = 6;
                            return this.getRelevantRoom(recipient);

                          case 6:
                            newRoomId = _context25.sent;
                            _context25.next = 9;
                            return this.client.promise;

                          case 9:
                            _context25.sent.sendTextMessage(newRoomId, msg).catch(function (error2) {
                              return __awaiter(_this10, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
                                return _regeneratorRuntime.wrap(function _callee24$(_context24) {
                                  while (1) {
                                    switch (_context24.prev = _context24.next) {
                                      case 0:
                                        logger.log("sendMessage", "inner error", error2);

                                      case 1:
                                      case "end":
                                        return _context24.stop();
                                    }
                                  }
                                }, _callee24);
                              }));
                            });

                            _context25.next = 13;
                            break;

                          case 12:
                            logger.log("sendMessage", "not forbidden", error);

                          case 13:
                          case "end":
                            return _context25.stop();
                        }
                      }
                    }, _callee25, this);
                  }));
                });

              case 33:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));
    }
  }, {
    key: "isTextMessage",
    value: function isTextMessage(content) {
      return content.message.type === MatrixMessageType.TEXT;
    }
  }, {
    key: "updateRelayServer",
    value: function updateRelayServer(sender) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
        var _this11 = this;

        var split, senderHash, relayServer, manager, peers, promiseArray;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                // Sender is in the format "@pubkeyhash:relayserver.tld"
                split = sender.split(':');

                if (!(split.length < 2 || !split[0].startsWith('@'))) {
                  _context28.next = 3;
                  break;
                }

                throw new Error('Invalid sender');

              case 3:
                senderHash = split.shift();
                relayServer = split.join(':');
                manager = localStorage.getItem('beacon:communication-peers-dapp') ? new PeerManager(this.storage, StorageKey.TRANSPORT_P2P_PEERS_DAPP) : new PeerManager(this.storage, StorageKey.TRANSPORT_P2P_PEERS_WALLET);
                _context28.next = 8;
                return manager.getPeers();

              case 8:
                peers = _context28.sent;
                promiseArray = peers.map(function (peer) {
                  return __awaiter(_this11, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
                    var hash;
                    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
                      while (1) {
                        switch (_context27.prev = _context27.next) {
                          case 0:
                            _context27.t0 = "@";
                            _context27.next = 3;
                            return getHexHash(Buffer.from(peer.publicKey, 'hex'));

                          case 3:
                            _context27.t1 = _context27.sent;
                            hash = _context27.t0.concat.call(_context27.t0, _context27.t1);

                            if (!(hash === senderHash)) {
                              _context27.next = 10;
                              break;
                            }

                            if (!(peer.relayServer !== relayServer)) {
                              _context27.next = 10;
                              break;
                            }

                            peer.relayServer = relayServer;
                            _context27.next = 10;
                            return manager.addPeer(peer);

                          case 10:
                          case "end":
                            return _context27.stop();
                        }
                      }
                    }, _callee27);
                  }));
                });
                _context28.next = 12;
                return Promise.all(promiseArray);

              case 12:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));
    }
  }, {
    key: "isChannelOpenMessage",
    value: function isChannelOpenMessage(content) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.t0 = content.message.content;
                _context29.t1 = "@channel-open:@";
                _context29.t2 = getHexHash;
                _context29.t3 = Buffer;
                _context29.next = 6;
                return this.getPublicKey();

              case 6:
                _context29.t4 = _context29.sent;
                _context29.t5 = _context29.t3.from.call(_context29.t3, _context29.t4, 'hex');
                _context29.next = 10;
                return (0, _context29.t2)(_context29.t5);

              case 10:
                _context29.t6 = _context29.sent;
                _context29.t7 = _context29.t1.concat.call(_context29.t1, _context29.t6);
                return _context29.abrupt("return", _context29.t0.startsWith.call(_context29.t0, _context29.t7));

              case 13:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));
    }
  }, {
    key: "isSender",
    value: function isSender(event, senderPublicKey) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.t0 = event.content.message.sender;
                _context30.t1 = "@";
                _context30.next = 4;
                return getHexHash(Buffer.from(senderPublicKey, 'hex'));

              case 4:
                _context30.t2 = _context30.sent;
                _context30.t3 = _context30.t1.concat.call(_context30.t1, _context30.t2);
                return _context30.abrupt("return", _context30.t0.startsWith.call(_context30.t0, _context30.t3));

              case 7:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30);
      }));
    }
  }, {
    key: "getRelevantRoom",
    value: function getRelevantRoom(recipient) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
        var roomIds, roomId, room;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return this.storage.get(StorageKey.MATRIX_PEER_ROOM_IDS);

              case 2:
                roomIds = _context31.sent;
                roomId = roomIds[recipient];

                if (roomId) {
                  _context31.next = 13;
                  break;
                }

                logger.log("getRelevantRoom", "No room found for peer ".concat(recipient, ", checking joined ones."));
                _context31.next = 8;
                return this.getRelevantJoinedRoom(recipient);

              case 8:
                room = _context31.sent;
                roomId = room.id;
                roomIds[recipient] = room.id;
                _context31.next = 13;
                return this.storage.set(StorageKey.MATRIX_PEER_ROOM_IDS, roomIds);

              case 13:
                logger.log("getRelevantRoom", "Using room ".concat(roomId));
                return _context31.abrupt("return", roomId);

              case 15:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));
    }
  }, {
    key: "getRelevantJoinedRoom",
    value: function getRelevantJoinedRoom(recipient) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
        var _this12 = this;

        var joinedRooms, relevantRooms, room, roomId;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.next = 2;
                return this.client.promise;

              case 2:
                _context32.next = 4;
                return _context32.sent.joinedRooms;

              case 4:
                joinedRooms = _context32.sent;
                logger.log('checking joined rooms', joinedRooms, recipient);
                relevantRooms = joinedRooms.filter(function (roomElement) {
                  return !_this12.ignoredRooms.some(function (id) {
                    return roomElement.id === id;
                  });
                }).filter(function (roomElement) {
                  return roomElement.members.some(function (member) {
                    return member === recipient;
                  });
                });

                if (!(relevantRooms.length === 0 || this.ignoredRooms.length > 0)) {
                  _context32.next = 25;
                  break;
                }

                logger.log("getRelevantJoinedRoom", "no relevant rooms found, creating new one");
                _context32.next = 11;
                return this.client.promise;

              case 11:
                _context32.next = 13;
                return _context32.sent.createTrustedPrivateRoom(recipient);

              case 13:
                roomId = _context32.sent;
                _context32.next = 16;
                return this.client.promise;

              case 16:
                _context32.next = 18;
                return _context32.sent.getRoomById(roomId);

              case 18:
                room = _context32.sent;
                logger.log("getRelevantJoinedRoom", "waiting for other party to join room: ".concat(room.id));
                _context32.next = 22;
                return this.waitForJoin(roomId);

              case 22:
                logger.log("getRelevantJoinedRoom", "new room created and peer invited: ".concat(room.id));
                _context32.next = 27;
                break;

              case 25:
                room = relevantRooms[0];
                logger.log("getRelevantJoinedRoom", "channel already open, reusing room ".concat(room.id));

              case 27:
                return _context32.abrupt("return", room);

              case 28:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));
    }
  }]);

  return P2PCommunicationClient;
}(CommunicationClient);